import type { IntegrationErrorResponse } from '@/definitions/common'
import { PRODUCT_FLAG_ROWS } from '@/definitions/productFlags'

/**
 * Indexes the reported failures by the flag they belong to.
 *
 * The first mention of a field wins; a second one for the same flag would be
 * describing the same failed call.
 */
export const mapIntegrationErrors = (
  errors: readonly IntegrationErrorResponse[]
): Record<string, string> => {
  const byField: Record<string, string> = {}

  for (const error of errors) {
    if (byField[error.field] === undefined) {
      byField[error.field] = error.message
    }
  }

  return byField
}

const ROW_FIELDS = new Set<string>(PRODUCT_FLAG_ROWS.map((row) => row.field))

/**
 * Failures that belong to no row on this screen.
 *
 * A flag the backend reports on but this screen does not show would otherwise be
 * dropped silently, leaving the operator believing a save fully applied. These are
 * surfaced on their own instead.
 */
export const unmatchedIntegrationErrors = (
  errors: readonly IntegrationErrorResponse[]
): IntegrationErrorResponse[] => errors.filter((error) => !ROW_FIELDS.has(error.field))
